import React, { Component } from "react";
import { Spin } from "antd";
import { history, showErrorNotification, strings } from "../../helpers";
import DoctorsListView from "./DoctorsListView";

import { getDoctorsList } from "../../services";

export default class DoctorsListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctorList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      filterBy: ""
    };
  }

  componentDidMount() {
    this.fetchDoctorsList();
  }

  /**
   * @function fetchDoctorsList
   * @description This function get doctors data
   */
  fetchDoctorsList = () => {
    const { pageNo, searchText, filterBy } = this.state;
    this.setState({
      isProcessing: true
    });
    getDoctorsList(pageNo, searchText, filterBy)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { doctors } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            doctorList: doctors,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            doctorList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ doctorList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @oaram page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, doctorList: [] }, () => {
      this.fetchDoctorsList();
    });
  };

  /**
   * @function handleSearchText
   * @description This function get called when clicked on search icon
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };
  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, doctorList: [] }, () => {
      this.fetchDoctorsList();
    });
  };

  /**
   * @function  handleFilterBy
   * @param value
   * @description This function get called when clicked on press enter
   */
  handleFilterBy = value => {
    this.setState({ pageNo: 1, doctorList: [], filterBy: value }, () => {
      this.fetchDoctorsList();
    });
  };

  /**
   * @function  navigateToClinicDetails
   * @description This function redirect the user to doctor-details
   */
  navigateToDoctorDetails = doctorId => {
    history.push(`/doctor-details/${doctorId}/basic-details`);
  };

  render() {
    const {
      doctorList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      filterBy
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <DoctorsListView
          navigateToDoctorDetails={this.navigateToDoctorDetails}
          doctorList={doctorList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          searchText={searchText}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          filterBy={filterBy}
          handleFilterBy={this.handleFilterBy}
        />
      </Spin>
    );
  }
}
